import type { World } from '../ecs/world'

/**
 * Dev overlay (F3): FPS, entity count, player state, and live editors for
 * the most-playtested tunables — attrition first (spec §13).
 */
export class DevOverlay {
  private root: HTMLElement
  private visible = false
  private stats!: HTMLElement

  constructor() {
    this.root = document.getElementById('dev-overlay')!
    window.addEventListener('keydown', (e) => {
      if (e.code === 'F3') {
        e.preventDefault()
        this.visible = !this.visible
        this.root.classList.toggle('hidden', !this.visible)
      }
    })
  }

  build(world: World): void {
    this.root.innerHTML = `
      <div class="dev-stats"></div>
      <div class="dev-edits">
        <label>attrition hp/s <input type="number" step="0.1" data-p="attrition.hpPerSecond"></label>
        <label>player speed <input type="number" step="5" data-p="player.speed"></label>
        <label>proj damage <input type="number" step="1" data-p="player.projectileDamage"></label>
        <label>gen interval <input type="number" step="0.1" data-p="generators.spawnInterval"></label>
        <label>food heal <input type="number" step="5" data-p="food.heal"></label>
      </div>`
    this.stats = this.root.querySelector('.dev-stats')!
    this.root.querySelectorAll<HTMLInputElement>('[data-p]').forEach((inp) => {
      const [group, key] = inp.dataset.p!.split('.') as [string, string]
      const g = (world.tuning as unknown as Record<string, Record<string, number>>)[group]!
      inp.value = String(g[key])
      inp.addEventListener('change', () => {
        const v = parseFloat(inp.value)
        if (!Number.isNaN(v)) g[key] = v
      })
    })
  }

  update(world: World, fps: number): void {
    if (!this.visible || !this.stats) return
    const p = world.players()[0]
    this.stats.textContent = [
      `fps ${fps.toFixed(0)}`,
      `entities ${world.entities.length}`,
      `particles ${world.particles.length}`,
      `floor ${world.floor} seed ${world.seed}`,
      p ? `hp ${p.hp?.toFixed(1)} pos ${(p.x / 32).toFixed(1)},${(p.y / 32).toFixed(1)}` : 'no player'
    ].join('  ·  ')
  }
}
